import React, { useEffect } from 'react';
import { gsap } from 'gsap';

const FadeTransition = ({ children, shouldAnimate }) => {
  useEffect(() => {
    const appContainer = document.querySelector('.app-container');
    const navigationContainer = document.querySelector('.navigation-container');
    
    if (appContainer && shouldAnimate) {

      gsap.to(appContainer.children, {
        opacity: 0,
        duration: 0.3,
        onComplete: () => {
          gsap.set(appContainer.children, { visibility: 'hidden' });
          
          gsap.to(appContainer.children, {
            opacity: 1,
            duration: 0.3,
            delay: 0.1,
            visibility: 'visible',
          });
        }
      });

      if (navigationContainer) {
        gsap.to(navigationContainer, {
          opacity: 0.6,
          duration: 0.3,
          onComplete: () => {
            gsap.to(navigationContainer, {
              opacity: 1,
              duration: 0.3,
              delay: 0.1,
            });
          }
        });
      }
    }
  }, [shouldAnimate]);

  return <>{children}</>;
};

export default FadeTransition;
